import React from 'react'
interface GoogleAnalyticsProps {
  pageLoadIdCookie?: string
  measurementId?: string
  googleAdsKey?: string
  sharingPolicyDenied?: boolean
}

export const GoogleAnalytics = ({
  pageLoadIdCookie,
  measurementId,
  googleAdsKey,
  sharingPolicyDenied,
}: GoogleAnalyticsProps) => {
  const disableAnalytics =
    process.env.NODE_ENV === 'development' ||
    sharingPolicyDenied ||
    !measurementId ||
    !pageLoadIdCookie ||
    !googleAdsKey
  if (disableAnalytics) {
    return null
  }
  return (
    <>
      <script key="gtag-loader" async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      <script
        key="gtag-init"
        id="gtag-init"
        async
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag() {
           setTimeout(() => {
             window.dataLayer.push(arguments);
           }, 1000);
          }
          gtag("js", new Date());
          gtag("config", "${googleAdsKey}");
          gtag("config", "${measurementId}", { page_load_id: "${pageLoadIdCookie}", 'stack': 'remix' });
          gtag("event", "nonceReady");
             `,
        }}
      />
    </>
  )
}
